import { Link } from "react-router-dom";
import { branchLabel, branchOf } from "../../lib/branch";
import { relationshipSummary } from "../../lib/connectionRelationships";
import { contactProfileForEntry } from "../../lib/privateContactProfile";

function nameOf(entry) {
  const profile = contactProfileForEntry(entry);
  return profile.full_name || entry.recipient_name || "Unknown";
}

/**
 * How this person sits in your network: where they came from, who you met
 * through them, and who they could introduce you to.
 */
export default function RelationshipsCard({
  entry,
  connection,
  entries = [],
  graph = null,
  context = null,
  onEditOrigin,
}) {
  const { through, introductions } = relationshipSummary({ entries, entry, graph, context });
  const origin = branchLabel(branchOf(connection));

  return (
    <section className="dossier-section">
      <div className="dossier-head">
        <h2>Relationships</h2>
      </div>

      <ul className="entry-list">
        <li className="entry">
          <div className="entry-row is-static">
            <span className="entry-meta">Origin</span>
            <span className="entry-title">
              {origin || "You met them directly."}
            </span>
          </div>
        </li>

        {through.length > 0 && (
          <li className="entry">
            <div className="entry-row is-static">
              <span className="entry-meta">Through them</span>
              <span className="entry-title">
                <span className="people-links">
                  {through.map((item) => (
                    <Link key={item.id} to={`/connections/${item.id}`}>
                      {nameOf(item)}
                    </Link>
                  ))}
                </span>
              </span>
            </div>
          </li>
        )}

        {introductions.length > 0 && (
          <li className="entry">
            <div className="entry-row is-static">
              <span className="entry-meta">Can introduce</span>
              <span className="entry-title">
                <span className="people-links is-static">
                  {introductions.slice(0, 6).map((node) => (
                    <span key={node.id}>
                      {node.profile?.full_name || "Someone in your extended network"}
                    </span>
                  ))}
                </span>
                <Link to="/search" className="entry-aside">Find an intro path →</Link>
              </span>
            </div>
          </li>
        )}
      </ul>

      <button type="button" className="link-button dossier-add" onClick={onEditOrigin}>
        {origin ? "Change how you met" : "+ Set how you met"}
      </button>
    </section>
  );
}
